const BaseModule = require('../../90_utils/base/BaseModule');

class ImageSwappable extends BaseModule {

	constructor(el, params) {

		super(el);

		// flags

		this._isListening = false;

		// element vars

		this.$currentImage = this.$el.find('.double-wrap');
		this.$nextImage;

		this.imageLoading;
		this.nextImageURL;
	}

	// private methods

	_addListeners(){

		if(!this._isListening){

			this._isListening = true;
			this.$el.on('swap', this._onSwap.bind(this));
		}

		super._addListeners();
	}

	_removeListeners(){

		if(this._isListening){

			this._isListening = false;

		}

		super._removeListeners();
	}

	// listener methods

	_onSwap(e, obj){
		console.log("swap image", e, obj);
	}

	_swapImage(imageURL, delta){

		if(delta !== 1 || delta !== -1){ delta = 1; }

		if(!this.imageLoading || (this.imageLoading && this.nextImageURL != imageURL)){

		}
	}
}

module.exports = ImageSwappable;
